import { AuthActions } from 'src/redux/actions/constant';

const {
  AUTO_GENERATE_PASSWORD_SUCCESS,
  AUTO_GENERATE_PASSWORD_FAILURE,
  AUTO_GENERATE_PASSWORD_RESET,
  AUTO_GENERATE_PASSWORD_LOADING,
} = AuthActions;
const intialState: object = {
  response: null,
  password: '',
  loading: false,
};

export const autoGeneratePasswordReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case AUTO_GENERATE_PASSWORD_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        password: action.payload.data?.password,
        loading: false,
      };
    }
    case AUTO_GENERATE_PASSWORD_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
      };
    }

    case AUTO_GENERATE_PASSWORD_LOADING:
      return {
        ...state,
        loading: true,
      };
    case AUTO_GENERATE_PASSWORD_RESET:
      return intialState;
    default:
      return state;
  }
};
